import SDK from 'bam-browser-sdk';

/**
 *
 * @class GeoProviderMock
 * @description A mock GeoProvider to pass to SDK.SdkSession.createSdkSession
 * @see https://github.bamtech.co/fed-core/browser-sdk/blob/master/docs/services/GeoProvider.md
 * @see https://github.bamtech.co/fed-core/browser-sdk/blob/master/docs/usage/Examples.md#create-sdksession
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/features/sdkSession.md#createsdksession
 *
 */
export default class GeoProviderMock extends SDK.Token.GeoProvider {

    /**
     *
     * @param {Number} [latitude=0]
     * @param {Number} [longitude=0]
     *
     */
    constructor(latitude = 0, longitude = 0) {

        super();

        /**
         *
         * @access public
         * @type {Number}
         * @desc The latitude of the location.
         *
         */
        this.latitude = latitude;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The longitude of the location.
         *
         */
        this.longitude = longitude;

    }

    /**
     *
     * @access public
     * @desc Retrieves the current GeoLocation of the device.
     * @returns {Promise<GeoLocation>}
     *
     */
    getGeoLocation(latitude = this.latitude, longitude = this.longitude) {

        return Promise.resolve({
            latitude,
            longitude
        });

    }

}



// WEBPACK FOOTER //
// ./src/geoProviderMock.js